
<div class="asset-result-item" *ngIf="asset" routerLink="/asset/{{asset.assetId}}">
    <div class="col icon"><mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="electric_meter"></mat-icon></div>
    <div class="col identifier-name">
    <div class="item">Serial number:</div>
    <div class="item">Asset ID:</div>
    <div class="item">LKL Country:</div>
    </div>
    <div class="col identifier-content">
        <div class="item">{{ asset.serialNumber }}</div>
        <div class="item">{{ asset.assetId }}</div>
        <div class="item">{{ asset.lastKnownLocation?.Country}}</div>
        </div>    
    <div class="col additional-name">
        <div class="item">Type designation:</div>
        <div class="item">Status:</div>
        <div class="item">LKL Name:</div>
    </div>
    <div class="col additional-content">
        <div class="item">{{ asset.typeCode }}&nbsp;</div>
        <div class="item">{{ asset.registrations?.length!=0 ? 'Registered' : 'Not registered' }}</div>
        <div class="item">{{ asset.lastKnownLocation?.Name}}</div>
    </div>    
</div>

<div class="asset-result-item" *ngIf="!asset">
    Error loading asset details.
</div>
<p *ngIf="!asset">Error loading asset search result</p>